import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Grid, Button, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import ContactDetailField from "../../../molecules/ContactDetailField";
import Input from "../../../atoms/Input";
import DynamicText from "../../../molecules/DynamicText";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import { useParams } from "react-router-dom";
import FourOptionsDynamicCheckbox from "../../../molecules/FourOptionsCheckbox";
// import "./style.css";
import { useLocation } from "react-router-dom";

const LoadUnloadDownload = ({ surveyData, formContent }) => {
  const [formContentId, setFormContentId] = useState("");

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  return (
    <>
      <div className="premium-print-container mx-4">
        <div className="section-divider mb-3">
          <h1 className="section-title">Load Unload Report</h1>
        </div>

        {/* file detail*/}
        <div className="data-grid mb-4">
          <div className="data-item">
            <span className="data-label">Customer Name</span>
            <span className="data-value">{formContent?.clientName || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">File Ref</span>
            <span className="data-value">{formContent?.fileRef || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Organization</span>
            <span className="data-value">{formContent?.organization || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Date</span>
            <span className="data-value">{formContent?.date ? formatDate(formContent?.date) : "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Driver Name</span>
            <span className="data-value">{formContent?.driverName || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Contact No.</span>
            <span className="data-value">{formContent?.contactNo || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">ID Card No.</span>
            <span className="data-value">{formContent?.idNo || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Serial No.</span>
            <span className="data-value">{formContent?.serialNo || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Truck No.</span>
            <span className="data-value">{formContent?.truckNo || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Container No.</span>
            <span className="data-value">{formContent?.containerNo || "-"}</span>
          </div>
        </div>

        {/* Addresses */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={6}>
            <span className="data-label">Origin Address</span>
            <p style={{ fontSize: '10pt', color: '#1e293b', margin: 0 }}>{formContent?.originAddress || "-"}</p>
          </Grid>
          <Grid item xs={6}>
            <span className="data-label">Destination Address</span>
            <p style={{ fontSize: '10pt', color: '#1e293b', margin: 0 }}>{formContent?.destinationAddress || "-"}</p>
          </Grid>
        </Grid>

        {/* Shipment Modes/Nature */}
        <div className="section-divider mb-2">
          <h2 className="section-title" style={{ fontSize: '11pt' }}>Shipment Overview</h2>
        </div>
        <div className="mb-4">
          <div className="data-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div>
              <span className="data-label mb-2 d-block">Shipment Mode</span>
              <div className="d-flex flex-wrap gap-3">
                {['Import', 'Export', 'Local', 'Storage'].map(mode => (
                  <span key={mode} style={{ fontSize: '10pt', color: formContent?.shipmentMode === mode.toLowerCase() ? '#0f172a' : '#94a3b8' }}>
                    [ {formContent?.shipmentMode === mode.toLowerCase() ? 'X' : ' '} ] {mode}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <span className="data-label mb-2 d-block">Nature of Shipment</span>
              <div className="d-flex flex-wrap gap-3">
                {['Loose Items', 'Lift Vans', 'Vehicle', 'Bike'].map(nature => {
                   const natureKey = nature.toLowerCase().replace(' ', '-');
                   return (
                    <span key={nature} style={{ fontSize: '10pt', color: formContent?.shipmentNature === natureKey ? '#0f172a' : '#94a3b8' }}>
                      [ {formContent?.shipmentNature === natureKey ? 'X' : ' '} ] {nature}
                    </span>
                   );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Containers/Packages Grid */}
        <div className="section-divider mb-2">
          <h2 className="section-title" style={{ fontSize: '11pt' }}>Package/Container Checklist</h2>
        </div>
        <div className="d-flex flex-wrap gap-1 mb-4">
          {formContent?.containers?.map((cn, ind) => (
            <div
              key={ind}
              style={{
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '9pt',
                fontWeight: 600,
                borderRadius: '4px',
                border: '1px solid #e2e8f0',
                background: cn ? '#0f172a' : 'transparent',
                color: cn ? '#ffffff' : '#94a3b8'
              }}
            >
              {ind + 1}
            </div>
          ))}
        </div>

        {/* Exceptions */}
        {(formContent?.doubleNo || formContent?.missingNo || formContent?.damagesNo) && (
          <div className="data-grid mb-4">
            <div className="data-item">
              <span className="data-label">Double No.</span>
              <span className="data-value">{formContent?.doubleNo || "-"}</span>
            </div>
            <div className="data-item">
              <span className="data-label">Missing No.</span>
              <span className="data-value">{formContent?.missingNo || "-"}</span>
            </div>
            <div className="data-item">
              <span className="data-label">Apparent Damages</span>
              <span className="data-value">{formContent?.damagesNo || "-"}</span>
            </div>
          </div>
        )}

        {/* Remarks */}
        {formContent?.remarks?.trim()?.length > 0 && (
          <div className="mb-4">
            <span className="data-label">Report Remarks</span>
            <p className="p-word mt-1" style={{ fontSize: '10pt' }}>{formContent.remarks}</p>
          </div>
        )}

        {/* Signatures */}
        <div className="mt-5 pt-4" style={{ pageBreakInside: 'avoid' }}>
          <Grid container spacing={4}>
            <Grid item xs={6} className="text-center">
              <div style={{ height: "80px", borderBottom: '1px solid #e2e8f0', marginBottom: '10px' }} className="d-flex justify-content-center align-items-center">
                {formContent?.supervisorSign && (
                  <img src={`${Bucket}${formContent.supervisorSign}`} height={70} style={{ objectFit: 'contain' }} />
                )}
              </div>
              <p className="fw-bold mb-0" style={{ fontSize: '10pt' }}>Supervisor / Carrier</p>
            </Grid>
            <Grid item xs={6} className="text-center">
              <div style={{ height: "80px", borderBottom: '1px solid #e2e8f0', marginBottom: '10px' }} className="d-flex justify-content-center align-items-center">
                {formContent?.ownerSign && (
                  <img src={`${Bucket}${formContent.ownerSign}`} height={70} style={{ objectFit: 'contain' }} />
                )}
              </div>
              <p className="fw-bold mb-0" style={{ fontSize: '10pt' }}>Owner / Authorized Representative</p>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default LoadUnloadDownload;
